import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header-component';
import { PdfPreviewComponent } from '../../observatory-single/components/pdf-preview/pdf-preview-component';

@Component({
  selector: 'app-layout-blank',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, PdfPreviewComponent],
  template: `
    <app-header></app-header>
    <div class="lbv-content">
      <router-outlet></router-outlet>
    </div>
    <app-pdf-preview></app-pdf-preview>
  `,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      height: 100dvh;
      overflow: hidden;
    }

    .lbv-content {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
  `],
})
export class LayoutBlankView {}
